import { api } from '@/App';

/**
 * Fire-and-forget analytics tracking.
 * Never throws — analytics must NEVER break the UX.
 */
export const track = (event, props = {}) => {
  try {
    api.post('/analytics/track', { event, props }).catch(() => {});
  } catch (e) {
    /* swallow */
  }
};
